import { Paper, Typography, Box, Chip, Stack } from '@mui/material';
import { tokens } from '../../../theme/theme';
import { severityChipSx, severityLabel, formatRelativeTime } from '../../../utils/severity';

export default function IncidentsPanel({ incidents }) {
  if (!incidents?.length) return null;
  return (
    <Paper sx={{ p: 2.4, height: '100%' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
        <Typography variant="overline" sx={{ color: tokens.text.muted, fontSize: '0.65rem' }}>
          Active Incidents
        </Typography>
        <Chip label={`${incidents.length} open`} size="small" sx={{ backgroundColor: tokens.bg.elevated, color: tokens.text.secondary }} />
      </Box>
      <Stack spacing={1.2}>
        {incidents.map((inc) => (
          <Box
            key={inc.id}
            sx={{
              p: 1.4, borderRadius: 1.5, border: `1px solid ${tokens.border}`,
              backgroundColor: tokens.bg.elevated, display: 'flex', flexDirection: 'column', gap: 0.6
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 1 }}>
              <Typography variant="body2" sx={{ color: tokens.text.primary, fontWeight: 500, fontSize: '0.82rem' }}>
                {inc.title}
              </Typography>
              <Chip label={severityLabel(inc.severity)} size="small" sx={{ ...severityChipSx(inc.severity), flexShrink: 0 }} />
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="caption" sx={{ color: tokens.text.muted, fontFamily: '"JetBrains Mono", monospace' }}>
                {inc.id} · {inc.client}
              </Typography>
              <Typography variant="caption" sx={{ color: tokens.text.muted }}>
                {formatRelativeTime(inc.opened)}
              </Typography>
            </Box>
          </Box>
        ))}
      </Stack>
    </Paper>
  );
}
